import * as React from "react";
import { useId } from "@floating-ui/react";
import { clsx } from "clsx";
import { Icon } from "../../icon/icon/icon.mjs";
import { useListboxItem } from "./use-listbox.mjs";
const ListboxOption = ({ value, label, description, icon: iconProp, className, ...rest }) => {
  const id = useId();
  const { ref, getItemProps, selected } = useListboxItem({ label, value });
  const labelId = "".concat(id, "-label");
  const descId = "".concat(id, "-desc");
  const icon = selected ? "#check" : iconProp;
  return /* @__PURE__ */ React.createElement("li", { ...rest, className: clsx("listbox__option", className), id, ref, "aria-labelledby": labelId, "aria-describedby": descId, ...getItemProps() }, icon && /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "listbox__option-icon", size: "xs" }), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "listbox__option-label", id: labelId }, label), /* @__PURE__ */ React.createElement("div", { className: "listbox__option-desc text-tiny", id: descId }, description)));
};
export {
  ListboxOption
};
